import {API_URL} from 'src/cms/constants/EndPoint'
import * as auth from '../../app/modules/auth/redux/actions'

export default function setupAxios(axios: any, store: any) {
  axios.defaults.headers.Accept = 'application/json'

  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {accessToken, guestToken, refreshToken},
      } = store.getState()

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      } else if (guestToken) {
        config.headers.Authorization = `Bearer ${guestToken}`
      }

      const fingerprint = sessionStorage.getItem('fingerprint')
      if (fingerprint) {
        config.headers['X-Fingerprint'] = fingerprint
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  if ((window as any).__RUNTIME_CONFIG__?.REACT_APP_NAME === 'instant') {
    let isRefreshing = false
    let failedQueue: Array<{resolve: (token: string) => void; reject: (err: any) => void}> = []

    const processQueue = (error: any, token: string | null = null) => {
      failedQueue.forEach((p) => (error ? p.reject(error) : p.resolve(token as string)))
      failedQueue = []
    }

    axios.interceptors.response.use(
      (response: any) => response,
      async (error: any) => {
        const originalRequest = error.config

        if (error.response?.status !== 401 || originalRequest._retry) {
          return Promise.reject(error)
        }

        const {
          auth: {refreshToken},
        } = store.getState()
        if (!refreshToken) {
          store.dispatch(auth.actions.logout())
          return Promise.reject(error)
        }

        if (isRefreshing) {
          return new Promise<string>((resolve, reject) => {
            failedQueue.push({resolve, reject})
          }).then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`
            return axios(originalRequest)
          })
        }

        originalRequest._retry = true
        isRefreshing = true

        try {
          // Bare instance: skips the request/response interceptors so the refresh
          // call carries no expired Bearer token and a 401 here can't re-enter
          // this handler and deadlock against isRefreshing.
          const response = await axios.create().post(`${API_URL}/login`, {
            refresh_token: refreshToken,
            token_type: 'refresh',
          })
          const newAccessToken: string = response?.data?.data?.token
          const newRefreshToken: string = response?.data?.data?.refresh_token

          store.dispatch({
            type: 'REFRESH_TOKEN_SUCCESS',
            payload: {accessToken: newAccessToken, refreshToken: newRefreshToken},
          })
          axios.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`

          processQueue(null, newAccessToken)
          return axios(originalRequest)
        } catch (refreshError: any) {
          processQueue(refreshError, null)
          store.dispatch(auth.actions.logout())
          return Promise.reject(refreshError)
        } finally {
          isRefreshing = false
        }
      }
    )
  }
}
